import React from 'react';
import styles from './style.module.css';

export default ({
    input,
    meta: {
        error,
        submitFailed
    } = {},
    name = input.name ? input.name : 'option-select',
    label = false,
    options = []
} = {}) => (
    <div
        className={
            submitFailed && error ? styles.inputError : styles.container
        }
    >
        <div className={styles.optionSelectContainer}>
            {
                label &&
                <p className={styles.optionSelectLabel}>
                    {label}
                </p>
            }
            <div>
                {
                    Object.keys(options).map((key) =>
                        <label
                            key={key}
                            htmlFor={key}
                            className={input.value === key ? styles.optionSelectItemSelected : styles.optionSelectItem}
                        >
                            <span className={styles.optionSelectItemTitle}>{options[key].title}</span>
                            <span className={styles.optionSelectItemContent}>{options[key].content}</span>
                            <input
                                id={key}
                                type='radio'
                                name={name}
                                value={key}
                                checked={input.value === key}
                                onChange={input.onChange}
                            />
                        </label>
                    )
                }
            </div>
        </div>
        {
            submitFailed && error &&
            error.map((message, i) => <span key={i} className={styles.errorMessage}>{message}</span>)
        }
    </div>
);
